import React from "react";
import Loader from '../../../../components/Loader';
import Page from '../../../../components/Page';
import HTTPManager from "../../../../utils/httpRequestManager";
// import TableView from '../../../../components/table/tableView';
import { toast, ToastContainer } from 'react-toastify';
import Iconify from '../../../../components/Iconify';
import FormManager from "../../../../components/formComponents/FormManager";
import schema from './schema.json';
import {Box, Grid, Card,  Container, Typography, Stack} from '@mui/material';
import FButton from '../../../../components/formComponents/components/button';
import { checkButtonAccess } from "../../../../utils/protector";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
  
    return result;
  };
   
  const grid = 0; 
  
  const getListStyle = isDraggingOver => ({
  //   background: isDraggingOver ? "lightblue" : "lightgrey",
    padding: grid,
  //   width: 250
  });
export default class Category extends React.Component{
    httpManager = new HTTPManager();

    constructor(){
        super();
        this.state={
            isLoading:false,
            schema:{},
            categorylist:[],
            addForm: false,
            selectedCategory:{},
            // columns:[
            //     {
            //         field: 'mCategoryName',
            //         headerName: 'Category Name',
            //         minWidth: 300,
            //         editable: false,
            //         renderCell: (params) => (
            //             <div style={{position:'relative', height:'100%', paddingLeft:'20px', display:'flex', alignItems:'center', marginLeft:'-10px'}}>
            //                 <div style={{position:'absolute', top:0, left:0, width:'5px', bottom:0, background: params.row.mCategoryColorCode}}>&nbsp;</div>
            //               {params.row.mCategoryName}
            //           </div>
            //         )
            //     },
            //     {
            //         field: 'mCategoryStatus',
            //         headerName: 'Status',
            //         minWidth: 300,
            //         editable: false,
            //         renderCell: (params) => (
            //           <div>
            //               {params.row.mCategoryStatus.toString() === '1' ? 'Active' : 'Inactive'}
            //           </div>
            //         )
            //     },
            //     {
            //         field: 'Action',
            //         headerName:'Actions',
            //         flex:1,
            //         minWidth:100,
            //         renderCell: (params) => (
            //             this.getActions(params)                    
            //         ),
            //     }
            // ]
        }
        this.handleCloseform = this.handleCloseform.bind(this); 
        this.updateRecord = this.updateRecord.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
    }

    getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: grid * 2,
        margin: `0 0 ${grid}px 0`, 
        // styles we need to apply on draggables
        ...draggableStyle
      });
    
    onDragEnd(result) { 
         // dropped outside the list
        if (!result.destination) {
            return;
        }
    
        const categorylist = reorder(
            this.state.categorylist,
            result.source.index,
            result.destination.index
        );
        const oldList = Object.assign([], this.state.categorylist)
        const categoryitems = categorylist.map((c,i)=>{
            return {
                id: c.id,
                sortOrder:i+1
            }
        })
        this.setState({ 
            categorylist
        });
        this.setState({isLoading:true},()=>{
            this.httpManager.postRequest('/merchant/category/reorder',{categories: categoryitems}).then(ees=>{
                this.setState({
                    isLoading: false,
                    categorylist
                });
            }).catch(e=>{
                this.setState({categorylist:oldList})
            })
        })
    };
    updateRecord(row, status){ 
        this.setState({isLoading: true}, ()=>{
            this.httpManager.postRequest(`merchant/category/update`, {mCategoryStatus: status, id: row.id}).then(res=>{
                //console.log(res.message);
                this.setState({isLoading: false});
                this.reloadData(res.message);
            })
        })
    }
    componentDidMount(){ 
        this.setState({schema: schema},()=>{
            this.reloadData();
        })
    }
    handleCloseform(){
        this.setState({addForm: false})
    }
    getActions(params){
        var detail = window.localStorage.getItem('userdetail')
        if(detail !== '' && detail !== undefined && detail !=='{}'){
          var userdetail = JSON.parse(detail);
        const btnBase = { border: 'none', borderRadius: '8px', padding: '5px 14px', fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer', transition: 'opacity 0.15s' };
        return <div style={{display:'flex', flexDirection:'row', gap:'8px', alignItems:'center'}}>

                {(checkButtonAccess('Inventory') === 'W'  || userdetail.userRole==='Owner') &&
                    <button style={{...btnBase, background:'transparent', border:'1.5px solid #0D1727', color:'#0D1727'}}
                        onClick={()=>this.openEdit(params.row)}>Edit</button>}

                {(checkButtonAccess('Inventory') === 'W' || userdetail.userRole==='Owner') && params.row.mCategoryStatus==='1' &&
                    <button style={{...btnBase, background:'#E53935', color:'#fff'}}
                        onClick={()=>{this.updateRecord(params.row, 0)}}>Deactivate</button>
                }
                {(checkButtonAccess('Inventory') === 'W' || userdetail.userRole==='Owner') && params.row.mCategoryStatus==='0' &&
                    <button style={{...btnBase, background:'#2E7D32', color:'#fff'}}
                        onClick={()=>{this.updateRecord(params.row, 1)}}>Activate</button>
                }

               {checkButtonAccess('Inventory') !== 'W' && userdetail.userRole !=='Owner' && <div style={{color:'#aaa',fontSize:'0.8rem'}}>N/A</div>}
            </div>
        }
    }
    openEdit(data){ 
        var schema = Object.assign({}, this.state.schema);
        var properties = Object.assign([], this.state.schema.properties);
        var props=[];
        properties.forEach((field,i)=>{
            field.value = data[field.name];
            props.push(field);
            if(i === properties.length-1){
                props.push({
                    "component":"TextField", 
                    "type": "hidden", 
                    "minLength": 1,
                    "maxLength": 50,
                    "grid":6,
                    "name":"id",
                    "label":"id",
                    "placeholder":"id",
                    "value":data.id
                  })
                schema.properties = props; 
                this.setState({schema: schema,selectedCategory: data},()=>{
                    this.setState({addForm: true})
                })
            }
        })
    }
    reloadData(msg=''){
        if(msg !== ''){ 
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton:false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
        this.setState({isLoading: true, addForm: false},()=>{
            this.httpManager.getRequest(`merchant/category/get`).then(response=>{
                //console.log(response)
                this.setState({categorylist: response.data, isLoading: false});
            })
        })
    }
    openAdd(){
        this.setState({schema: schema,selectedCategory: {}},()=>{
            var schemaobj = Object.assign({}, schema);

            var properties = Object.assign([], this.state.schema.properties);
            var props=[];
            properties.forEach((field,i)=>{
                delete field["value"];
                props.push(field);
                if(i === properties.length-1){
                    schemaobj.properties = props;
                }
            });
            this.setState({schema:schemaobj}, ()=>{
                this.setState({addForm: true}) 
            })
        })
    }
    render(){
        return <Page title="Category | Astro POS">
            {this.state.isLoading && <Loader show={this.state.isLoading} />}
            <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            />
            {!this.state.addForm ?
                <Container maxWidth="xl">
                    {/* ── Header ── */}
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
                        <div>
                            <Typography variant="h4" style={{ fontWeight: 700, color: '#0D1727' }}>
                                Category
                            </Typography>
                            <Typography variant="body2" style={{ color: '#6B7280', marginTop: '2px' }}>
                                Manage and reorder your service categories
                            </Typography>
                        </div>
                        {checkButtonAccess('Inventory') === 'W' &&
                            <button onClick={() => this.openAdd()} style={{
                                display: 'flex', alignItems: 'center', gap: '6px',
                                background: '#0D1727', color: '#fff', border: 'none',
                                borderRadius: '10px', padding: '10px 20px',
                                fontSize: '0.9rem', fontWeight: 700, cursor: 'pointer',
                                boxShadow: '0 2px 8px rgba(13,23,39,0.18)',
                            }}>
                                <span style={{ fontSize: '1.1rem', lineHeight: 1 }}>+</span> Add Category
                            </button>
                        }
                    </Stack>

                    {/* ── Table card ── */}
                    <div style={{
                        background: '#fff', borderRadius: '16px',
                        boxShadow: '0 2px 12px rgba(0,0,0,0.07)', overflow: 'hidden',
                    }}>
                        {/* Table header */}
                        <div style={{
                            display: 'flex', alignItems: 'center',
                            background: '#F8F9FA', borderBottom: '1px solid #E5E7EB',
                            padding: '0 24px', height: '44px',
                        }}>
                            <div style={{ flex: 2, fontSize: '12px', fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Category Name</div>
                            <div style={{ flex: 1, fontSize: '12px', fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Status</div>
                            <div style={{ flex: 1.5, fontSize: '12px', fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Actions</div>
                        </div>

                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Droppable droppableId="droppable">
                                {(provided, snapshot) => (
                                    <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver)}
                                    >
                                        {this.state.categorylist.map((item, index) => (
                                            <Draggable key={item.id} draggableId={item.id} index={index}>
                                                {(provided, snapshot) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={{
                                                            ...this.getItemStyle(snapshot.isDragging, provided.draggableProps.style),
                                                        }}
                                                    >
                                                        <div style={{
                                                            display: 'flex', alignItems: 'center',
                                                            padding: '0 24px', height: '56px',
                                                            background: snapshot.isDragging ? '#EBF5FB' : '#fff',
                                                            borderBottom: '1px solid #F3F4F6',
                                                            transition: 'background 0.15s',
                                                        }}>
                                                            {/* Name with color stripe */}
                                                            <div style={{ flex: 2, display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                                <div style={{ width: '4px', height: '32px', borderRadius: '4px', background: item.mCategoryColorCode || '#ccc', flexShrink: 0 }} />
                                                                <span style={{ fontWeight: 600, color: '#1F2937', fontSize: '0.9rem' }}>{item.mCategoryName}</span>
                                                            </div>
                                                            {/* Status badge */}
                                                            <div style={{ flex: 1 }}>
                                                                <span style={{
                                                                    display: 'inline-block',
                                                                    padding: '3px 12px', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 700,
                                                                    background: item.mCategoryStatus === '1' ? '#D1FAE5' : '#F3F4F6',
                                                                    color: item.mCategoryStatus === '1' ? '#065F46' : '#6B7280',
                                                                }}>
                                                                    {item.mCategoryStatus === '1' ? 'Active' : 'Inactive'}
                                                                </span>
                                                            </div>
                                                            {/* Actions */}
                                                            <div style={{ flex: 1.5 }}>
                                                                {this.getActions({ row: item })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </Container> : ''
            }
            {this.state.addForm && <Box sx={{ width: '100%' }}>
                <Grid container spacing={3} alignItems="center" justifyContent="center" style={{ marginLeft: 0, marginRight: 0, width: '100%', fontWeight: 'bold' }}>
                    <Grid item xs={12}>
                        <Stack spacing={3}>
                            <FormManager formProps={this.state.schema} reloadData={(msg) => this.reloadData(msg)} closeForm={() => this.handleCloseform()} />
                        </Stack>
                    </Grid>
                </Grid>
            </Box>}
        </Page>
    }
}